module.exports = __webpack_public_path__ + "img/file-text-grey.d53606f3.svg";